import { buildExportUrl } from "./graySchoolRouting";

const DEFAULT_LANGUAGE = "zh";

export function setupVueGlobals({ Vue, Tool, Common, echarts, ApiService, Urls }) {
  Vue.config.productionTip = false;
  Vue.prototype.$Tool = Tool;
  Vue.prototype.$Common = Common;
  Vue.prototype.$echarts = echarts;
  Vue.prototype.$http = ApiService;
  Vue.prototype.$Urls = Urls;
  Vue.prototype.$buildExportUrl = (url) => buildExportUrl(url, Urls, Tool);
  // 上传接口完整 URL（含公共鉴权参数），灰度校自动切换 Java base URL
  Vue.prototype.$uploadAction = function(path) {
    const base = buildExportUrl(Urls.crmApiUrl, Urls, Tool);
    const token = Tool.getStorage("token") || "";
    const company_id = Tool.getStorage("company_id") || "";
    const school_id = Tool.getStorage("school_id") || "";
    const marketer_id = Tool.getStorage("marketer_id") || "";
    const staffer_id = Tool.getStorage("staffer_id") || "";
    const re_postbe_id = Tool.getStorage("re_postbe_id") || "";
    const postbe_crmuserlevel = Tool.getStorage("PostbeCrmlevel") || "";
    const language_type = Tool.getStorage("language") || "zh";
    return `${base}${path}?token=${token}&company_id=${company_id}&school_id=${school_id}&marketer_id=${marketer_id}&staffer_id=${staffer_id}&re_postbe_id=${re_postbe_id}&postbe_crmuserlevel=${postbe_crmuserlevel}&language_type=${language_type}`;
  };
}

export function resolveLocaleLanguage(Tool) {
  if (window.location.href.indexOf("havePermission") > -1) {
    return Tool.getParameter("language") || DEFAULT_LANGUAGE;
  }
  return Tool.getStorage("language") || DEFAULT_LANGUAGE;
}

export function buildUserInfo(Tool, languageType) {
  return {
    marketer_id: Tool.getStorage("marketer_id"),
    USER_TOKEN: Tool.getStorage("token"),
    STAFFER_ID: Tool.getStorage("staffer_id"),
    COMPANY_ID: Tool.getStorage("company_id"),
    SCHOOL_ID: Tool.getStorage("school_id"),
    postbe_crmuserlevel: Tool.getStorage("PostbeCrmlevel"),
    re_postbe_id: Tool.getStorage("re_postbe_id") || "0",
    language_type: languageType,
  };
}

export function buildExportParamStr(userInfo) {
  return `?token=${userInfo.USER_TOKEN}&school_id=${userInfo.SCHOOL_ID}&marketer_id=${userInfo.marketer_id}&postbe_crmuserlevel=${userInfo.postbe_crmuserlevel}&company_id=${userInfo.COMPANY_ID}&staffer_id=${userInfo.STAFFER_ID}&language_type=${userInfo.language_type}&re_postbe_id=${userInfo.re_postbe_id}`;
}

export function applyUserContext(Vue, userInfo) {
  Vue.prototype.$exportParameStr = buildExportParamStr(userInfo);
  Vue.prototype.$userinfo = userInfo;
}

